import { StorageType } from "api/entities/shard-repository";
import { StorageABS } from "../storages/abs";
import { StorageGCS } from "../storages/gcs";
import { StorageS3 } from "../storages/s3";
import { IStorageExternal } from "../storages/storage-external";

class StorageExternalFactory {
    public getStorage(type: StorageType): IStorageExternal {
        switch (type) {
            case "ABS":
                return new StorageABS();
            case "GCS":
                return new StorageGCS();
            case "S3":
            case "s3p":
                return new StorageS3();
        }
    }
}

export const storageExternalFactory = new StorageExternalFactory();
